import { ActionTypes } from '../constants';

// Reducer
function calendarReducer(
  calendar = {
    list: [],
    selected: '',
    mode: null,
    calendarRules: { CalendarModeAreaIds: {} }
  },
  action
) {
  switch (action.type) {
    case ActionTypes.GET_CALENDAR:
      const newCalendar = action.calendar;
      return {
        ...newCalendar,
        mode: calendar.mode,
        calendarRules: calendar.calendarRules
      };

    case ActionTypes.SELECT_CALENDAR_DATE:
      return { ...calendar, selected: action.selected };

    case ActionTypes.SET_CALENDAR_MODE:
      return { ...calendar, mode: action.mode };

    case ActionTypes.GET_CALENDAR_RULES:
      return { ...calendar, calendarRules: action.calendarRules };

    default:
      return calendar;
  }
}

export default calendarReducer;



// WEBPACK FOOTER //
// ./src/reducers/calendar.js